// Debug aid only: remove this module, its call sites and the
// /add-cluster/old route in routes/legacy.ts before v3 launches.
const ALIASES = [{ host: '/add-cluster/old', sub: '/add-cluster' }] as const;

function swapPrefix(path: string, from: string, to: string): string | null {
  const rest = path.slice(from.length);
  if (!path.startsWith(from) || (rest && !/^[/?#]/.test(rest))) return null;
  return to + rest;
}

export function hostToSubPath(hostPath: string): string {
  for (const alias of ALIASES) {
    const sub = swapPrefix(hostPath, alias.host, alias.sub);
    if (sub !== null) return sub;
  }
  return hostPath;
}

/**
 * Only while the host is on an alias: the sub's /add-cluster?… navigation must
 * stay on the alias rather than hand over to the native wizard mid-create.
 */
export function subToHostPath(subPath: string, hostPath: string): string {
  for (const alias of ALIASES) {
    if (swapPrefix(hostPath, alias.host, alias.sub) === null) continue;
    const host = swapPrefix(subPath, alias.sub, alias.host);
    if (host !== null) return host;
  }
  return subPath;
}
